module.exports = __webpack_public_path__ + "img/xmasParty9.bbc847e3.jpg";